module.exports = __webpack_public_path__ + "static/Aston-20191_attjtd-f6c7673d18dde877fe7abb38a30ff214.jpg";